import styled from 'styled-components/macro';
import { fontSize, fontWeight, lineHeight, space } from '../../../theme/tokens';
import * as StaffCommon from '../../common/elements/Staff';

export const DoubleHeaderGroup = styled(StaffCommon.StaffHeaderGroup)`
  flex-direction: column;
  align-items: flex-start;
  gap: ${space[1]};
  min-width: 0;
`;

export const TopicSubHeader = styled.h3`
  margin: 0;
  padding-left: ${space[2]};
  font-size: ${fontSize.sm};
  font-weight: ${fontWeight.semibold};
  line-height: ${lineHeight.tight};
  color: ${({ theme }) => theme.subHeaderColour};
  overflow-wrap: anywhere;
`;

export const ModuleSubHeader = styled.h2`
  margin: 0;
  padding-left: ${space[2]};
  font-style: normal;
  font-weight: ${fontWeight.bold};
  font-size: ${fontSize.xl};
  line-height: ${lineHeight.tight};
  color: ${({ theme }) => theme.subHeaderColour};
  overflow-wrap: anywhere;
`;

export * from '../../common/elements/Staff.js';
